import CombinedProvider from "./src/context/CombinedProvider"

export const wrapRootElement = CombinedProvider